var map = {
	"./akekuri/akekuri.json": 51674,
	"./akekuri/potentials/potential-1-positive-feedback.json": 9972,
	"./akekuri/potentials/potential-2-passionate-idealist.json": 20945,
	"./akekuri/potentials/potential-3-committed-team-player.json": 2557,
	"./akekuri/potentials/potential-4-super-perfect-status.json": 91702,
	"./akekuri/potentials/potential-5-tempo-of-awareness.json": 47716,
	"./akekuri/skills/basic-attack-batk-sword-of-aspiration.json": 29372,
	"./akekuri/skills/basic-attack-dive-sword-of-aspiration.json": 52838,
	"./akekuri/skills/basic-attack-finisher-sword-of-aspiration.json": 94904,
	"./akekuri/skills/battle-skill-burst-of-passion.json": 96304,
	"./akekuri/skills/combo-skill-flash-and-dash.json": 11671,
	"./akekuri/skills/ultimate-squad-on-me.json": 57984,
	"./akekuri/talents/talent-cheer-of-victory-talent.json": 70048,
	"./akekuri/talents/talent-staying-in-the-zone-talent.json": 35200,
	"./alesh/alesh.json": 86442,
	"./alesh/potentials/potential-1-super-salty-comeback.json": 37705,
	"./alesh/potentials/potential-2-calm-and-tranquil.json": 35315,
	"./alesh/potentials/potential-3-may-the-willing-bite.json": 46963,
	"./alesh/potentials/potential-4-insane-angling-set.json": 60613,
	"./alesh/potentials/potential-5-mega-lunker-rumors.json": 91049,
	"./alesh/skills/basic-attack-batk-rod-casting.json": 87698,
	"./alesh/skills/basic-attack-dive-rod-casting.json": 39028,
	"./alesh/skills/basic-attack-finisher-rod-casting.json": 72118,
	"./alesh/skills/battle-skill-unconventional-lure.json": 1903,
	"./alesh/skills/combo-skill-auger-angling.json": 40964,
	"./alesh/skills/ultimate-one-monster-catch.json": 617,
	"./alesh/talents/talent-flash-frozen-talent.json": 81332,
	"./alesh/talents/talent-veteran-angler-talent.json": 23098,
	"./antal/antal.json": 51114,
	"./antal/potentials/potential-1-arts-talent.json": 31956,
	"./antal/potentials/potential-2-improved-automation.json": 11298,
	"./antal/potentials/potential-3-applied-originium-theory.json": 71616,
	"./antal/potentials/potential-4-grannys-reminder.json": 19661,
	"./antal/potentials/potential-5-high-specs-tech-tester.json": 59265,
	"./antal/skills/basic-attack-batk-exchange-current.json": 11399,
	"./antal/skills/basic-attack-dive-exchange-current.json": 15069,
	"./antal/skills/basic-attack-finisher-exchange-current.json": 77195,
	"./antal/skills/battle-skill-specified-research-subject.json": 66899,
	"./antal/skills/combo-skill-emp-test-site.json": 50735,
	"./antal/skills/ultimate-overclocked-moment.json": 9349,
	"./antal/statuses/status-focus.json": 214,
	"./antal/statuses/status-improviser.json": 33216,
	"./antal/statuses/status-overclocked-moment-amp.json": 78921,
	"./antal/talents/talent-improviser-talent.json": 92422,
	"./antal/talents/talent-subconscious-act-talent.json": 21555,
	"./arclight/arclight.json": 24036,
	"./arclight/potentials/potential-1-child-of-the-storm.json": 24621,
	"./arclight/potentials/potential-2-speed-battler.json": 6542,
	"./arclight/potentials/potential-3-hanna.json": 93613,
	"./arclight/potentials/potential-4-aldertones-teachings.json": 74566,
	"./arclight/potentials/potential-5-servant-of-the-wildlands.json": 98167,
	"./arclight/skills/basic-attack-batk-seek-and-hunt.json": 24178,
	"./arclight/skills/basic-attack-dive-seek-and-hunt.json": 7404,
	"./arclight/skills/basic-attack-finisher-seek-and-hunt.json": 34166,
	"./arclight/skills/battle-skill-tempestuous-arc.json": 86131,
	"./arclight/skills/combo-skill-peal-of-thunder.json": 80885,
	"./arclight/skills/ultimate-exploding-blitz.json": 37205,
	"./arclight/statuses/status-wildland-trekker-buff.json": 73982,
	"./arclight/talents/talent-hannabit-wisdom-talent.json": 55037,
	"./arclight/talents/talent-wildland-trekker-talent.json": 34778,
	"./ardelia/ardelia.json": 69098,
	"./ardelia/potentials/potential-1-dolly-paradise.json": 9353,
	"./ardelia/potentials/potential-2-game-rewards.json": 99075,
	"./ardelia/potentials/potential-3-explosive-eruption.json": 15471,
	"./ardelia/potentials/potential-4-rock-blossom.json": 22711,
	"./ardelia/potentials/potential-5-volcanic-steam.json": 88839,
	"./ardelia/skills/action-mr-dolly-shadow.json": 68221,
	"./ardelia/skills/basic-attack-batk-rocky-whispers.json": 99100,
	"./ardelia/skills/basic-attack-dive-rocky-whispers.json": 44834,
	"./ardelia/skills/basic-attack-finisher-rocky-whispers.json": 50288,
	"./ardelia/skills/battle-skill-dolly-rush.json": 38141,
	"./ardelia/skills/combo-skill-eruption-column.json": 32615,
	"./ardelia/skills/ultimate-wooly-party.json": 98680,
	"./ardelia/talents/talent-friendly-presence-talent.json": 26805,
	"./ardelia/talents/talent-mountainpeak-surfer-talent.json": 73544,
	"./avywenna/avywenna.json": 42874,
	"./avywenna/potentials/potential-1-doubling-down.json": 56983,
	"./avywenna/potentials/potential-2-pole-of-menace.json": 9301,
	"./avywenna/potentials/potential-3-hard-negotiator.json": 35616,
	"./avywenna/potentials/potential-4-very-experienced.json": 26822,
	"./avywenna/potentials/potential-5-carrot-and-sharp-stick.json": 88025,
	"./avywenna/skills/basic-attack-batk-thunderlance-blitz.json": 44474,
	"./avywenna/skills/basic-attack-dive-thunderlance-blitz.json": 13424,
	"./avywenna/skills/basic-attack-finisher-thunderlance-blitz.json": 47870,
	"./avywenna/skills/battle-skill-thunderlance-interdiction.json": 97837,
	"./avywenna/skills/combo-skill-thunderlance-strike.json": 91959,
	"./avywenna/skills/ultimate-thunderlance-final-shock.json": 29379,
	"./avywenna/statuses/status-thunderlance-ex-pierce.json": 98163,
	"./avywenna/statuses/status-thunderlance-ex.json": 31836,
	"./avywenna/statuses/status-thunderlance-pierce.json": 96869,
	"./avywenna/statuses/status-thunderlance.json": 18,
	"./avywenna/talents/talent-expedited-delivery-talent.json": 99454,
	"./avywenna/talents/talent-tactful-approach-talent.json": 1687,
	"./catcher/catcher.json": 21266,
	"./catcher/potentials/potential-1-multi-layered-readiness.json": 40334,
	"./catcher/potentials/potential-2-bonus-spec-training.json": 75356,
	"./catcher/potentials/potential-3-unwavering-post.json": 26684,
	"./catcher/potentials/potential-4-compensated-suffering.json": 2321,
	"./catcher/potentials/potential-5-choice-without-regrets.json": 12188,
	"./catcher/skills/basic-attack-batk-rigid-interdiction-basic.json": 78591,
	"./catcher/skills/basic-attack-dive-rigid-interdiction-basic.json": 86809,
	"./catcher/skills/basic-attack-finisher-rigid-interdiction-basic.json": 93283,
	"./catcher/skills/battle-skill-rigid-interdiction.json": 58216,
	"./catcher/skills/combo-skill-timely-suppression.json": 66604,
	"./catcher/skills/ultimate-textbook-assault.json": 97333,
	"./catcher/statuses/status-rigid-interdiction-retaliation-burst.json": 22244,
	"./catcher/statuses/status-rigid-interdiction-retaliation.json": 15175,
	"./catcher/talents/talent-comprehensive-mindset-talent.json": 76957,
	"./catcher/talents/talent-resilient-defense-talent.json": 60216,
	"./chen-qianyu/chen-qianyu.json": 57146,
	"./chen-qianyu/potentials/potential-1-shadowless.json": 40776,
	"./chen-qianyu/potentials/potential-2-heirloom-martial-arts.json": 7733,
	"./chen-qianyu/potentials/potential-3-dual-wielding-swordmancer.json": 19451,
	"./chen-qianyu/potentials/potential-4-improvised-chi-xiao.json": 46749,
	"./chen-qianyu/potentials/potential-5-bonded-with-the-world.json": 46483,
	"./chen-qianyu/skills/basic-attack-batk-soaring-break.json": 37531,
	"./chen-qianyu/skills/basic-attack-dive-soaring-break.json": 3681,
	"./chen-qianyu/skills/basic-attack-finisher-soaring-break.json": 38695,
	"./chen-qianyu/skills/battle-skill-ascending-strike.json": 52525,
	"./chen-qianyu/skills/combo-skill-soar-to-the-stars.json": 16611,
	"./chen-qianyu/skills/ultimate-blade-gale.json": 75627,
	"./chen-qianyu/talents/talent-momentum-breaker-talent.json": 28025,
	"./chen-qianyu/talents/talent-slashing-edge-talent.json": 1015,
	"./da-pan/da-pan.json": 75274,
	"./da-pan/potentials/potential-1-fine-cooking.json": 15599,
	"./da-pan/potentials/potential-2-harmonized-flavors.json": 13716,
	"./da-pan/potentials/potential-3-model-employee.json": 10116,
	"./da-pan/potentials/potential-4-special-blend.json": 77824,
	"./da-pan/potentials/potential-5-fire-it-up.json": 43214,
	"./da-pan/skills/basic-attack-batk-rolling-cut.json": 22691,
	"./da-pan/skills/basic-attack-dive-rolling-cut.json": 27313,
	"./da-pan/skills/basic-attack-finisher-rolling-cut.json": 83895,
	"./da-pan/skills/battle-skill-flip-da-wok.json": 55530,
	"./da-pan/skills/combo-skill-more-spice.json": 55429,
	"./da-pan/skills/ultimate-chop-n-dunk.json": 75374,
	"./da-pan/statuses/status-prep-ingredients.json": 20469,
	"./da-pan/talents/talent-reduce-and-thicken-talent.json": 16906,
	"./da-pan/talents/talent-salty-or-mild-talent.json": 66853,
	"./ember/ember.json": 83162,
	"./ember/potentials/potential-1-nomadic-fort.json": 15181,
	"./ember/potentials/potential-2-steel-hardened-veteran.json": 84702,
	"./ember/potentials/potential-3-indomitable-front.json": 53162,
	"./ember/potentials/potential-4-undying-embers.json": 14964,
	"./ember/potentials/potential-5-the-steel-oath.json": 17538,
	"./ember/skills/basic-attack-batk-sword-art-of-assault.json": 1286,
	"./ember/skills/basic-attack-dive-sword-art-of-assault.json": 21232,
	"./ember/skills/basic-attack-finisher-sword-art-of-assault.json": 66930,
	"./ember/skills/battle-skill-forward-march-empowered.json": 66961,
	"./ember/skills/battle-skill-forward-march.json": 14354,
	"./ember/skills/combo-skill-frontline-support.json": 32650,
	"./ember/skills/ultimate-re-ignited-oath.json": 37565,
	"./ember/statuses/status-inflamed-for-the-assault.json": 15335,
	"./ember/statuses/status-the-steel-oath-empowered.json": 69700,
	"./ember/statuses/status-the-steel-oath.json": 38263,
	"./ember/talents/talent-inflamed-for-the-assault-talent.json": 67957,
	"./ember/talents/talent-pay-the-ferric-price-talent.json": 39159,
	"./endministrator/endministrator.json": 37874,
	"./endministrator/potentials/potential-1-final-awakening.json": 71370,
	"./endministrator/potentials/potential-2-reflection-of-authority.json": 30434,
	"./endministrator/potentials/potential-3-.json": 96092,
	"./endministrator/potentials/potential-4-.json": 81443,
	"./endministrator/potentials/potential-5-.json": 15618,
	"./endministrator/skills/basic-attack-batk-destructive-sequence.json": 14115,
	"./endministrator/skills/basic-attack-dive-destructive-sequence.json": 6997,
	"./endministrator/skills/basic-attack-finisher-destructive-sequence.json": 48279,
	"./endministrator/skills/battle-skill-constructive-sequence.json": 72332,
	"./endministrator/skills/combo-skill-sealing-sequence.json": 30100,
	"./endministrator/skills/ultimate-bombardment-sequence.json": 63809,
	"./endministrator/statuses/status-essence-disintegration-minor.json": 66328,
	"./endministrator/statuses/status-originium-crystals-shatter.json": 44650,
	"./endministrator/talents/talent-essence-disintegration-talent.json": 63048,
	"./endministrator/talents/talent-realspace-stasis.json": 64622,
	"./estella/estella.json": 20962,
	"./estella/potentials/potential-1-habitual-delay.json": 75370,
	"./estella/potentials/potential-2-lowered-expectations.json": 33144,
	"./estella/potentials/potential-3-delayed-work.json": 88437,
	"./estella/potentials/potential-4-life-over-mission.json": 86258,
	"./estella/potentials/potential-5-survival-is-a-win.json": 56857,
	"./estella/skills/basic-attack-batk-audio-noise.json": 43085,
	"./estella/skills/basic-attack-dive-audio-noise.json": 66703,
	"./estella/skills/basic-attack-finisher-audio-noise.json": 41153,
	"./estella/skills/battle-skill-onomatopoeia.json": 69321,
	"./estella/skills/combo-skill-distortion.json": 72681,
	"./estella/skills/ultimate-tremolo.json": 63013,
	"./estella/talents/talent-commiseration-talent.json": 47836,
	"./estella/talents/talent-laziness-pays-off-now-talent.json": 32326,
	"./fluorite/fluorite.json": 71816,
	"./fluorite/potentials/potential-1-ten-finger-smith.json": 49754,
	"./fluorite/potentials/potential-2-mind-reading-technique.json": 6962,
	"./fluorite/potentials/potential-3-triple-surprise.json": 46171,
	"./fluorite/potentials/potential-4-prank-master.json": 29153,
	"./fluorite/potentials/potential-5-craver-of-chaos.json": 37929,
	"./fluorite/skills/basic-attack-batk-signature-gun-kata.json": 1463,
	"./fluorite/skills/basic-attack-dive-signature-gun-kata.json": 87657,
	"./fluorite/skills/basic-attack-finisher-signature-gun-kata.json": 14547,
	"./fluorite/skills/battle-skill-tiny-surprise.json": 5310,
	"./fluorite/skills/combo-skill-free-giveaway.json": 46436,
	"./fluorite/skills/ultimate-apex-prankster.json": 41696,
	"./fluorite/statuses/status-improvised-explosive-ult.json": 33408,
	"./fluorite/statuses/status-improvised-explosive.json": 25246,
	"./fluorite/talents/talent-love-the-stab-and-twist-talent.json": 96549,
	"./fluorite/talents/talent-unpredictable-talent.json": 65576,
	"./generic/status-forged.json": 17483,
	"./generic/status-keen-mind.json": 89156,
	"./generic/status-skirmisher.json": 71217,
	"./generic/status-stalwart.json": 43966,
	"./gilberta/gilberta.json": 13576,
	"./gilberta/potentials/potential-1-above-the-clouds.json": 97445,
	"./gilberta/potentials/potential-2-wind-walker.json": 97981,
	"./gilberta/potentials/potential-3-quick-gentle-steps.json": 71266,
	"./gilberta/potentials/potential-4-dances-with-clouds.json": 81840,
	"./gilberta/potentials/potential-5-special-mail.json": 47964,
	"./gilberta/skills/basic-attack-batk-beam-cohesion-arts.json": 93149,
	"./gilberta/skills/basic-attack-dive-beam-cohesion-arts.json": 46351,
	"./gilberta/skills/basic-attack-finisher-beam-cohesion-arts.json": 70513,
	"./gilberta/skills/battle-skill-gravity-mode.json": 67796,
	"./gilberta/skills/combo-skill-matrix-displacement.json": 18299,
	"./gilberta/skills/ultimate-gravity-field.json": 8496,
	"./gilberta/statuses/status-anomalous-gravity-field.json": 66695,
	"./gilberta/talents/talent-late-reply-talent.json": 44399,
	"./gilberta/talents/talent-messenger-s-song-talent.json": 4037,
	"./laevatain/laevatain.json": 84354,
	"./laevatain/potentials/potential-1-heart-of-melting-flame.json": 99753,
	"./laevatain/potentials/potential-2-pursuit-of-memories.json": 18067,
	"./laevatain/potentials/potential-3-fragments-from-the-past.json": 6601,
	"./laevatain/potentials/potential-4-ice-cream-furnace.json": 37080,
	"./laevatain/potentials/potential-5-proof-of-existence.json": 59891,
	"./laevatain/skills/basic-attack-batk-flaming-cinders-enhanced.json": 63313,
	"./laevatain/skills/basic-attack-batk-flaming-cinders.json": 95456,
	"./laevatain/skills/basic-attack-dive-flaming-cinders.json": 62438,
	"./laevatain/skills/basic-attack-finisher-flaming-cinders.json": 46764,
	"./laevatain/skills/battle-skill-smouldering-fire-empowered.json": 63200,
	"./laevatain/skills/battle-skill-smouldering-fire-enhanced-empowered.json": 81299,
	"./laevatain/skills/battle-skill-smouldering-fire-enhanced.json": 24880,
	"./laevatain/skills/battle-skill-smouldering-fire.json": 37523,
	"./laevatain/skills/combo-skill-seethe.json": 25129,
	"./laevatain/skills/ultimate-twilight.json": 80908,
	"./laevatain/statuses/status-melting-flame.json": 99429,
	"./laevatain/statuses/status-scorching-heart.json": 59944,
	"./laevatain/talents/talent-re-ignition-talent.json": 33492,
	"./laevatain/talents/talent-scorching-heart.json": 71049,
	"./last-rite/last-rite.json": 71722,
	"./last-rite/potentials/potential-1-undertakers-gift.json": 95715,
	"./last-rite/potentials/potential-2-absolute-zero-armament.json": 92899,
	"./last-rite/potentials/potential-3-overlord-of-winter.json": 50507,
	"./last-rite/potentials/potential-4-sincere-wake.json": 92047,
	"./last-rite/potentials/potential-5-winter-is-returning.json": 40575,
	"./last-rite/skills/basic-attack-batk-dance-of-rime.json": 87236,
	"./last-rite/skills/basic-attack-dive-dance-of-rime.json": 75670,
	"./last-rite/skills/basic-attack-finisher-dance-of-rime.json": 98520,
	"./last-rite/skills/battle-skill-esoteric-legacy.json": 9091,
	"./last-rite/skills/combo-skill-winters-devourer.json": 88964,
	"./last-rite/skills/ultimate-vigil-services.json": 18300,
	"./last-rite/statuses/status-hypothermic-perfusion-mirage.json": 11083,
	"./last-rite/statuses/status-hypothermic-perfusion.json": 65049,
	"./last-rite/statuses/status-vigil-services-ue-lockout.json": 99916,
	"./last-rite/talents/talent-cryogenic-embrittlement-talent.json": 27461,
	"./last-rite/talents/talent-hypothermia-talent.json": 83061,
	"./lifeng/lifeng.json": 32826,
	"./lifeng/potentials/potential-1-breaking-the-obsession.json": 65883,
	"./lifeng/potentials/potential-2-self-refinement.json": 56207,
	"./lifeng/potentials/potential-3-spiritual-cultivation.json": 91212,
	"./lifeng/potentials/potential-4-brief-instant.json": 4137,
	"./lifeng/potentials/potential-5-unremitting.json": 19414,
	"./lifeng/skills/basic-attack-batk-ruination.json": 72064,
	"./lifeng/skills/basic-attack-dive-ruination.json": 25634,
	"./lifeng/skills/basic-attack-finisher-ruination.json": 6908,
	"./lifeng/skills/battle-skill-turbid-avatar.json": 49353,
	"./lifeng/skills/combo-skill-aspect-of-wrath.json": 7362,
	"./lifeng/skills/ultimate-heart-of-the-unmoving.json": 19798,
	"./lifeng/talents/talent-illumination-talent.json": 15236,
	"./lifeng/talents/talent-subduer-of-evil-t2.json": 60830,
	"./perlica/perlica.json": 79518,
	"./perlica/potentials/potential-1-crisis-handling.json": 67522,
	"./perlica/potentials/potential-2-negotiation-tactics.json": 82843,
	"./perlica/potentials/potential-3-supervisory-duties.json": 47659,
	"./perlica/potentials/potential-4-constant-guidance.json": 38597,
	"./perlica/potentials/potential-5-reentry-control.json": 63164,
	"./perlica/skills/basic-attack-batk-protocol-alpha-breach.json": 18659,
	"./perlica/skills/basic-attack-dive-protocol-alpha-breach.json": 87545,
	"./perlica/skills/basic-attack-finisher-protocol-alpha-breach.json": 32287,
	"./perlica/skills/battle-skill-protocol-omega-strike.json": 44713,
	"./perlica/skills/combo-skill-instant-protocol-chain.json": 79820,
	"./perlica/skills/ultimate-protocol-epsilon.json": 76806,
	"./perlica/talents/talent-cycle-protocol-talent.json": 78627,
	"./perlica/talents/talent-obliteration-protocol-talent.json": 98477,
	"./pogranichnik/pogranichnik.json": 76034,
	"./pogranichnik/potentials/potential-1-frontline-sweep.json": 1598,
	"./pogranichnik/potentials/potential-2-advance.json": 60213,
	"./pogranichnik/potentials/potential-3-when-the-banner-flutters.json": 43257,
	"./pogranichnik/potentials/potential-4-shield-of-talos-ii.json": 46363,
	"./pogranichnik/potentials/potential-5-newly-forged-blade.json": 46792,
	"./pogranichnik/skills/basic-attack-batk-all-out-offensive.json": 90215,
	"./pogranichnik/skills/basic-attack-dive-all-out-offensive.json": 4213,
	"./pogranichnik/skills/basic-attack-finisher-all-out-offensive.json": 73531,
	"./pogranichnik/skills/battle-skill-the-pulverizing-front.json": 52282,
	"./pogranichnik/skills/combo-skill-full-moon-slash.json": 6780,
	"./pogranichnik/skills/ultimate-shieldguard-banner.json": 66495,
	"./pogranichnik/statuses/status-fervent-morale.json": 34904,
	"./pogranichnik/statuses/status-steel-oath-decisive-assault.json": 72464,
	"./pogranichnik/statuses/status-steel-oath-harass.json": 13740,
	"./pogranichnik/statuses/status-steel-oath.json": 80337,
	"./pogranichnik/talents/talent-tactical-instruction-talent.json": 41717,
	"./pogranichnik/talents/talent-the-living-banner-talent.json": 79733,
	"./rossi/potentials/potential-1-origin-of-admiration.json": 9822,
	"./rossi/potentials/potential-2-gap-to-perfection.json": 87110,
	"./rossi/potentials/potential-3-tangible-duties.json": 21585,
	"./rossi/potentials/potential-4-innocent-wish.json": 4078,
	"./rossi/potentials/potential-5-legendary-destination.json": 25011,
	"./rossi/rossi.json": 12602,
	"./rossi/skills/basic-attack-dive-seething-wolfblood.json": 47880,
	"./rossi/skills/basic-attack-finisher-seething-wolfblood.json": 43638,
	"./rossi/skills/basic-attack-seething-wolfblood.json": 93727,
	"./rossi/skills/battle-skill-crimson-shadow-empowered.json": 1285,
	"./rossi/skills/battle-skill-crimson-shadow.json": 57382,
	"./rossi/skills/combo-skill-moment-of-blazing-shadow-empowered.json": 49336,
	"./rossi/skills/combo-skill-moment-of-blazing-shadow.json": 48443,
	"./rossi/skills/ultimate-razorclaw-ambuscade.json": 62942,
	"./rossi/statuses/status-blazing-shadow-crit.json": 3251,
	"./rossi/statuses/status-perfect-timing.json": 51548,
	"./rossi/statuses/status-razor-clawmark.json": 75783,
	"./rossi/talents/talent-nicks-and-scratches.json": 76066,
	"./rossi/talents/talent-seething-blood.json": 92679,
	"./snowshine/potentials/potential-1-cold-shelter.json": 28741,
	"./snowshine/potentials/potential-2-storm-region.json": 43756,
	"./snowshine/potentials/potential-3-polar-survival-guide.json": 76889,
	"./snowshine/potentials/potential-4-tundra-aegis.json": 45416,
	"./snowshine/potentials/potential-5-cold-disaster-specialist.json": 28475,
	"./snowshine/skills/basic-attack-batk-hypothermic-assault.json": 5718,
	"./snowshine/skills/basic-attack-dive-hypothermic-assault.json": 79748,
	"./snowshine/skills/basic-attack-finisher-hypothermic-assault.json": 25186,
	"./snowshine/skills/battle-skill-saturated-defense.json": 35494,
	"./snowshine/skills/combo-skill-polar-rescue.json": 73816,
	"./snowshine/skills/ultimate-frigid-snowfield.json": 5638,
	"./snowshine/snowshine.json": 48242,
	"./snowshine/statuses/status-saturated-defense-retaliation-burst.json": 60550,
	"./snowshine/statuses/status-saturated-defense-retaliation.json": 86381,
	"./snowshine/statuses/status-snow-zone.json": 85376,
	"./snowshine/statuses/status-snowfield-sar-assistance.json": 3645,
	"./snowshine/talents/talent-polar-survival-talent.json": 63317,
	"./snowshine/talents/talent-sar-professional-talent.json": 13088,
	"./tangtang/potentials/potential-1-reserve-hoard.json": 22622,
	"./tangtang/potentials/potential-2-rivers-daughter.json": 12986,
	"./tangtang/potentials/potential-3-chiefly-vibe.json": 49040,
	"./tangtang/potentials/potential-4-qingbo-meditation.json": 61611,
	"./tangtang/potentials/potential-5-chiefs-all-eldritch-gaze.json": 68251,
	"./tangtang/skills/basic-attack-batk-basic-attack.json": 8341,
	"./tangtang/skills/basic-attack-dive-basic-attack.json": 42455,
	"./tangtang/skills/basic-attack-finisher-basic-attack.json": 95313,
	"./tangtang/skills/battle-skill-battle-skill.json": 25054,
	"./tangtang/skills/combo-skill-combo-skill.json": 28200,
	"./tangtang/skills/ultimate-ultimate.json": 5508,
	"./tangtang/statuses/status-early-rogue-wave.json": 23442,
	"./tangtang/statuses/status-olden-stare.json": 94420,
	"./tangtang/statuses/status-waterspout-ult.json": 73490,
	"./tangtang/statuses/status-waterspout.json": 60552,
	"./tangtang/statuses/status-whirlpool.json": 72318,
	"./tangtang/talents/talent-fam-of-honor-talent.json": 81259,
	"./tangtang/talents/talent-riot-bringer-talent.json": 31886,
	"./tangtang/tangtang.json": 53452,
	"./wulfgard/potentials/potential-1-lone-wolf.json": 49434,
	"./wulfgard/potentials/potential-2-firearm-mods.json": 61840,
	"./wulfgard/potentials/potential-3-hunting-hour.json": 78957,
	"./wulfgard/potentials/potential-4-will-of-the-pack.json": 34452,
	"./wulfgard/potentials/potential-5-natural-predator.json": 95800,
	"./wulfgard/skills/basic-attack-batk-rapid-fire-akimbo.json": 77318,
	"./wulfgard/skills/basic-attack-dive-rapid-fire-akimbo.json": 6723,
	"./wulfgard/skills/basic-attack-finisher-rapid-fire-akimbo.json": 14701,
	"./wulfgard/skills/battle-skill-thermite-tracers-empowered.json": 42478,
	"./wulfgard/skills/battle-skill-thermite-tracers.json": 66629,
	"./wulfgard/skills/combo-skill-frag-grenade-beta.json": 3522,
	"./wulfgard/skills/ultimate-wolven-fury.json": 75795,
	"./wulfgard/statuses/status-wulfgard-natural-predator.json": 47224,
	"./wulfgard/talents/talent-code-of-restraint-talent.json": 46364,
	"./wulfgard/talents/talent-scorching-fangs-minor-talent.json": 99782,
	"./wulfgard/talents/talent-scorching-fangs-talent.json": 12850,
	"./wulfgard/wulfgard.json": 6304,
	"./xaihi/potentials/potential-1-agile-execution.json": 28972,
	"./xaihi/potentials/potential-2-link-aggregation.json": 73344,
	"./xaihi/potentials/potential-3-mapping-node.json": 76931,
	"./xaihi/potentials/potential-4-grayscale-release.json": 84796,
	"./xaihi/potentials/potential-5-controlled-recursion.json": 76071,
	"./xaihi/skills/basic-attack-batk-basic-attack.json": 62762,
	"./xaihi/skills/basic-attack-dive-basic-attack.json": 75152,
	"./xaihi/skills/basic-attack-finisher-basic-attack.json": 98310,
	"./xaihi/skills/battle-skill-distributed-dos.json": 77905,
	"./xaihi/skills/combo-skill-stress-testing.json": 956,
	"./xaihi/skills/ultimate-stack-overflow.json": 85191,
	"./xaihi/statuses/status-auxiliary-crystal.json": 64780,
	"./xaihi/statuses/status-distributed-dos-amp.json": 69342,
	"./xaihi/statuses/status-execute-process.json": 27316,
	"./xaihi/talents/talent-execute-process-talent.json": 35574,
	"./xaihi/talents/talent-freeze-protocol-talent.json": 46341,
	"./xaihi/xaihi.json": 94410,
	"./yvonne/potentials/potential-1-flash-freezer.json": 67852,
	"./yvonne/potentials/potential-2-flawless-creation.json": 28294,
	"./yvonne/potentials/potential-3-tink-a-power.json": 94284,
	"./yvonne/potentials/potential-4-rebellious-mood.json": 34039,
	"./yvonne/potentials/potential-5-expert-mechcrafter.json": 62963,
	"./yvonne/skills/basic-attack-batk-exuberant-trigger-empowered.json": 8445,
	"./yvonne/skills/basic-attack-batk-exuberant-trigger.json": 21806,
	"./yvonne/skills/basic-attack-dive-exuberant-trigger.json": 50656,
	"./yvonne/skills/basic-attack-finisher-exuberant-trigger.json": 55770,
	"./yvonne/skills/battle-skill-brr-brr-bomb.json": 79057,
	"./yvonne/skills/combo-skill-flashfreezer.json": 60756,
	"./yvonne/skills/ultimate-cryoblasting-pistolier.json": 2621,
	"./yvonne/statuses/status-barrage-of-technology.json": 74864,
	"./yvonne/statuses/status-crit-damage.json": 91005,
	"./yvonne/statuses/status-crit-stacks.json": 64245,
	"./yvonne/talents/talent-barrage-of-technology-talent.json": 17890,
	"./yvonne/talents/talent-freezing-point-talent.json": 81206,
	"./yvonne/yvonne.json": 20310,
	"./zhuang-fangyi/potentials/potential-1-four-symbols-of-harmony.json": 91364,
	"./zhuang-fangyi/potentials/potential-2-acuity-of-fine-details.json": 33319,
	"./zhuang-fangyi/potentials/potential-3-sense-and-response.json": 75071,
	"./zhuang-fangyi/potentials/potential-4-absolute-composure.json": 4783,
	"./zhuang-fangyi/potentials/potential-5-storm-of-transformation.json": 76232,
	"./zhuang-fangyi/skills/basic-attack-batk-jolting-arts-enhanced.json": 44983,
	"./zhuang-fangyi/skills/basic-attack-batk-jolting-arts.json": 68894,
	"./zhuang-fangyi/skills/basic-attack-dive-jolting-arts.json": 75324,
	"./zhuang-fangyi/skills/basic-attack-finisher-jolting-arts.json": 37322,
	"./zhuang-fangyi/skills/battle-skill-mantra-of-sundering-enhanced.json": 70940,
	"./zhuang-fangyi/skills/battle-skill-mantra-of-sundering.json": 44679,
	"./zhuang-fangyi/skills/combo-skill-breath-of-transformation-enhanced.json": 93733,
	"./zhuang-fangyi/skills/combo-skill-breath-of-transformation.json": 33196,
	"./zhuang-fangyi/skills/ultimate-smiting-tempest.json": 34921,
	"./zhuang-fangyi/statuses/status-smiting-tempest-battle.json": 43365,
	"./zhuang-fangyi/statuses/status-sunderblade.json": 35049,
	"./zhuang-fangyi/talents/talent-force-of-nature.json": 47786,
	"./zhuang-fangyi/talents/talent-ordained-by-heaven.json": 93531,
	"./zhuang-fangyi/zhuang-fangyi.json": 56562
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96317;